var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1641 0.754256C12.9905 0.580613 12.7083 0.580613 12.5346 0.754256L6.99976 6.3L1.45403 0.754256C1.28038 0.580613 0.998212 0.580613 0.824569 0.754256C0.650925 0.9279 0.650925 1.21007 0.824569 1.38371L6.67418 7.23333C6.761 7.32015 6.86953 7.36356 6.98891 7.36356C7.09744 7.36356 7.21682 7.32015 7.30364 7.23333L13.1533 1.38371C13.3377 1.21007 13.3377 0.9279 13.1641 0.754256Z",
    fill: "#6B6B6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/selectArrow.76f6594f7fcb5d663ca815b5685f0d74.svg";
export { ForwardRef as ReactComponent };